import { LayoutDashboard, Users, CreditCard, Package, ShoppingCart, Building2, Crown, FileText, TestTube2, MessageSquare, Bell, Database, Shield, Activity, BarChart3, Target, Handshake, Building, MessageCircle, Search, BookOpen, Video as LucideIcon } from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  path: string;
  badge?: () => number | null;
  requiredRole?: AdminRole[];
  comingSoon?: boolean;
}

export interface NavSection {
  id: string;
  label: string;
  items: NavItem[];
}

export type AdminRole = 'superadmin' | 'admin' | 'support' | 'sales' | 'readonly';

export const ADMIN_NAV_SECTIONS: NavSection[] = [
  {
    id: 'pilotage',
    label: 'Pilotage',
    items: [
      {
        id: 'dashboard',
        label: 'Tableau de bord',
        icon: LayoutDashboard,
        path: '/admin',
      },
      {
        id: 'reports',
        label: 'Rapports',
        icon: BarChart3,
        path: '/admin/reports',
      },
    ],
  },
  {
    id: 'crm',
    label: 'CRM Stratégique',
    items: [
      {
        id: 'crm-pipeline',
        label: 'Pipeline',
        icon: Handshake,
        path: '/admin/crm/pipeline',
        requiredRole: ['superadmin', 'admin'],
      },
      {
        id: 'prospects',
        label: 'Prospects',
        icon: Target,
        path: '/admin/crm/prospects',
        requiredRole: ['superadmin', 'admin'],
      },
      {
        id: 'crm-analyse',
        label: 'Analyse',
        icon: BarChart3,
        path: '/admin/crm/analyse',
        requiredRole: ['superadmin', 'admin'],
      },
      {
        id: 'deals',
        label: 'Deals',
        icon: Handshake,
        path: '/admin/crm/deals',
        comingSoon: true,
        requiredRole: ['superadmin', 'admin', 'sales'],
      },
      {
        id: 'organizations',
        label: 'Organisations',
        icon: Building,
        path: '/admin/crm/organizations',
        comingSoon: true,
        requiredRole: ['superadmin', 'admin', 'sales'],
      },
      {
        id: 'interactions',
        label: 'Interactions',
        icon: MessageCircle,
        path: '/admin/crm/interactions',
        comingSoon: true,
        requiredRole: ['superadmin', 'admin', 'sales'],
      },
    ],
  },
  {
    id: 'clients-revenus',
    label: 'Clients & Revenus',
    items: [
      {
        id: 'users',
        label: 'Utilisateurs',
        icon: Users,
        path: '/admin/users',
      },
      {
        id: 'subscriptions',
        label: 'Abonnements',
        icon: CreditCard,
        path: '/admin/subscriptions',
      },
      {
        id: 'plans',
        label: 'Plans tarifaires',
        icon: Package,
        path: '/admin/plans',
      },
      {
        id: 'orders',
        label: 'Commandes',
        icon: ShoppingCart,
        path: '/admin/orders',
      },
    ],
  },
  {
    id: 'produit',
    label: 'Produit',
    items: [
      {
        id: 'modules',
        label: 'Modules métiers',
        icon: Building2,
        path: '/admin/modules',
      },
      {
        id: 'beta-founders',
        label: 'Beta Founders',
        icon: Crown,
        path: '/admin/beta-founders',
      },
      {
        id: 'cms',
        label: 'Contenu (CMS)',
        icon: FileText,
        path: '/admin/cms',
      },
      {
        id: 'qa',
        label: 'QA / Recette',
        icon: TestTube2,
        path: '/admin/qa',
      },
    ],
  },
  {
    id: 'marketing',
    label: 'Marketing',
    items: [
      {
        id: 'seo',
        label: 'Gestion SEO',
        icon: Search,
        path: '/admin/seo',
        requiredRole: ['superadmin', 'admin'],
      },
      {
        id: 'blog',
        label: 'Blog',
        icon: BookOpen,
        path: '/admin/blog/posts',
        requiredRole: ['superadmin', 'admin'],
      },
    ],
  },
  {
    id: 'support-ops',
    label: 'Support & Ops',
    items: [
      {
        id: 'support',
        label: 'Support',
        icon: MessageSquare,
        path: '/admin/support',
      },
      {
        id: 'alerts',
        label: 'Alertes',
        icon: Bell,
        path: '/admin/alerts',
      },
      {
        id: 'backups',
        label: 'Sauvegardes',
        icon: Database,
        path: '/admin/backups',
      },
      {
        id: 'diagnostic',
        label: 'Diagnostic',
        icon: Activity,
        path: '/admin/diagnostic',
      },
    ],
  },
  {
    id: 'securite',
    label: 'Sécurité',
    items: [
      {
        id: 'security',
        label: 'Sécurité',
        icon: Shield,
        path: '/admin/security',
      },
    ],
  },
];

export function hasAccessToNavItem(item: NavItem, userRole: AdminRole): boolean {
  if (!item.requiredRole || item.requiredRole.length === 0) {
    return true;
  }
  return item.requiredRole.includes(userRole);
}

export function filterNavSections(sections: NavSection[], userRole: AdminRole): NavSection[] {
  return sections
    .map(section => ({
      ...section,
      items: section.items.filter(item => hasAccessToNavItem(item, userRole)),
    }))
    .filter(section => section.items.length > 0);
}
